import { BaseDBItemModel, DefaultModel } from './default-model';
import { NetGeoDataIsEqualModel } from './net-geo-data';

export enum CountryField {
  Code = 'code',
  Cpm = 'cpm',
  Name = 'name',
}

export enum OfferGeoField {
  Bid = 'bid',
  Koef = 'koef',
  AutoBid = 'autoBid',
  CntLimit = 'cntLimit',
  DayCntLimit = 'dayCntLimit',
  SumLimit = 'sumLimit',
  DaySumLimit = 'daySumLimit',
  Url = 'url',
  Geo = 'geo',
  Offer = 'offer',
  CreatedBy = 'createdBy',

  Ecpm = 'ecpm',

  // use in OfferGeoService for additional property
  HasSchedule = 'hasSchedule',
}

export interface CountryModel extends BaseDBItemModel {
  code: string;
  cpm?: number;
  name: string;
}

export interface OfferGeoModel extends DefaultModel {
  autoBid: number;
  bid: number;
  cntLimit: number;
  dayCntLimit: number;
  daySumLimit: number;
  geo?: CountryModel;
  koef: number;
  sumLimit: number;
  url: string;

  ecpm: number; // RBid
  proposed_bid: number; // new Auto Bid

  [OfferGeoField.Offer]: string;
  [OfferGeoField.CreatedBy]?: string;
}

export interface OfferGeoHasScheduleModel extends OfferGeoModel {
  [OfferGeoField.HasSchedule]: boolean;
  netGeoData?: NetGeoDataIsEqualModel;
}
